@keyframes waveAndJump {
  0% { transform: translateY(0) scale(1); }
  15% {
    transform: translateY(-1px) scale(1.02);
    color: var(--active-color);
  }
  50%, 100% {
    transform: translateY(0) scale(1);
    color: var(--base-color);
  }
}

.container {
  display: flex;
  align-items: center;
  position: relative;
}

.statusWrapper {
  display: flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;

  max-width: 0;
  opacity: 0;
  transform: translateX(-10px);
  transition:
          max-width 0.5s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.3s ease-in-out,
          transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &.active {
    max-width: 300px;
    opacity: 1;
    transform: translateX(3px);
  }
}

.animatedText {
  display: flex;
  font-size: 13px;
  padding-right: 12px;

  span {
    display: inline-block;
    will-change: transform, color;
    animation: waveAndJump 4s cubic-bezier(0.45, 0.15, 0.55, 0.95) infinite;
    animation-delay: calc(var(--index) * 0.03s);
  }
}

.staticText {
  span {
    animation: none !important;
    color: inherit !important;
    transform: none !important;
    will-change: auto !important;
  }
}

.statusLoading {
  --base-color: #666;
  --active-color: #ea1b0a;
  color: var(--base-color);
}

.statusSuccess {
  color: #2e7d32;
}

.statusError {
  color: #c62828;
}